import * as R from 'ramda'

import {
  MultiSelectObjectOption,
  MultiSelectOption,
  MultiSelectOptionValue,
  MultiSelectValue,
} from './types'

export function isStringOption(value: MultiSelectOption): value is string {
  return typeof value === 'string'
}

export function isOptionDisabled(option: MultiSelectOption): boolean {
  return !isStringOption(option) && option.disabled === true
}

function toSelectionValues(value: MultiSelectValue): MultiSelectOptionValue[] {
  if (Array.isArray(value)) {
    return value
  }

  if (value === null || value === undefined || value === '') {
    return []
  }

  return [value]
}

function findOption(
  options: MultiSelectOption[],
  value: MultiSelectOptionValue,
): MultiSelectOption | undefined {
  return options.find((option) => {
    if (isStringOption(option)) {
      return option === value
    }

    return R.equals(option.value, value)
  })
}

export function hasNewDisabledSelection(
  next: MultiSelectValue,
  previous: MultiSelectValue,
  options: MultiSelectOption[],
): boolean {
  const previousValues = toSelectionValues(previous)

  return toSelectionValues(next).some((value) => {
    const alreadySelected = previousValues.some((previousValue) =>
      R.equals(previousValue, value),
    )

    if (alreadySelected) {
      return false
    }

    const option = findOption(options, value)

    return option ? isOptionDisabled(option) : false
  })
}

export function isSearchTermIncludedInOption(
  option: MultiSelectObjectOption | string,
  searchTerm: string,
): boolean {
  const name = isStringOption(option) ? option : option.name

  return name.toLowerCase().includes(searchTerm.toLowerCase())
}
